import { useQuery } from "@tanstack/react-query";

import { getFootprintingDairyManureStorage } from "services";

import { FOOTPRINTING_DAIRY_MANURE_STORAGE } from "consts";

export const useGetFootprintingDairyManureStorage = (primaryDataId?: string) =>
  useQuery({
    queryKey: [FOOTPRINTING_DAIRY_MANURE_STORAGE, primaryDataId],
    queryFn: () => getFootprintingDairyManureStorage(primaryDataId ?? ""),
    enabled: !!primaryDataId,
    gcTime: 0,
  });
